import React from "react";
import { Box, Flex, Text, Link, useDisclosure, Image } from "@chakra-ui/react";
import { FaTiktok, FaInstagram, FaFacebookF } from "react-icons/fa";
import { SiBluesky } from "react-icons/si";
import SubscriptionPolicyModal from "../policies/SubscriptionPolicyModal";
import PrivacyPolicyModal from "../policies/PrivacyPolicyModal";
import TermsOfServiceModal from "../policies/TermsOfServiceModal";
import Contact from "../Home/Contact";

const Footer = () => {
  // Chakra UI hooks for modals
  const {
    isOpen: isSubscriptionOpen,
    onOpen: onSubscriptionOpen,
    onClose: onSubscriptionClose,
  } = useDisclosure();

  const {
    isOpen: isPrivacyOpen,
    onOpen: onPrivacyOpen,
    onClose: onPrivacyClose,
  } = useDisclosure();

  const {
    isOpen: isTermsOpen,
    onOpen: onTermsOpen,
    onClose: onTermsClose,
  } = useDisclosure();

  const {
    isOpen: isContactOpen,
    onOpen: openContact,
    onClose: closeContact,
  } = useDisclosure();
  return (
    <Box
      p={10}
      bg="dark.500"
      color="primary.100"
      position="absolute"
      bottom={0}
      left={0}
      right={0}
    >
      {/* Main Footer */}
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        mx="auto"
      >
        {/* Address Section */}
        <Flex
          direction="column"
          textAlign={{ base: "center", md: "left" }}
          mb={{ base: 3, md: 0 }}
        >
          <Text my={2} fontWeight="bold" color="dark.900">
            Address
          </Text>
          <Text>9466 Georgia Ave #1100</Text>
          <Text>Silver Spring, MD 20910</Text>
          <Text>United States</Text>
        </Flex>

        {/* Logo Section */}
        <Flex align="center" justify="center" mb={{ base: 3, md: 0 }}>
          <Link href="/">
            <Image
              src={`${process.env.PUBLIC_URL}/assets/logo_beatstake/beatstake.gif`}
              w="8rem"
              alt="Logo"
              cursor="pointer"
            />
          </Link>
        </Flex>

        {/* Contact Section with Social Media Links */}
        <Flex
          direction="column"
          textAlign={{ base: "center", md: "right" }}
          align={{ base: "center", md: "flex-end" }}
        >
          <Link
            as="button"
            onClick={openContact} 
            my={3} 
            fontWeight="bold"
            color="dark.900"
            textDecoration="underline"
            _hover={{ textDecoration: "underline", color: "primary.900" }}
          >
            Contact Us
          </Link>
          <Text>support@beatstake.com</Text>
          <Flex mt={2} gap={4}>
            <Link
              href="https://www.tiktok.com/@beatstake"
              isExternal
              color="primary.100"
              _hover={{ color: "primary.900" }}
            >
              <FaTiktok size="24px" />
            </Link>
            <Link
              href="https://www.instagram.com/beatstake_official"
              isExternal
              color="primary.100"
              _hover={{ color: "primary.900" }}
            >
              <FaInstagram size="24px" />
            </Link>
            <Link
              href="https://bsky.app/profile/beatstakeofficial.bsky.social"
              isExternal
              color="primary.100"
              _hover={{ color: "primary.900" }}
            >
              <SiBluesky size="24px" />
            </Link>
            <Link
              href="https://www.facebook.com/beatstakeofficial"
              isExternal
              color="primary.100"
              _hover={{ color: "primary.900" }}
            >
              <FaFacebookF size="24px" />
            </Link>
          </Flex>
        </Flex>
      </Flex>

      {/* Footer Bottom with Policy Links */}
      <Box
        borderTopWidth={1}
        borderColor="secondary.900"
        py={10}
        textAlign="center"
        mt={3}
      >
        <Flex
          direction={{ base: "column", md: "row" }}
          align="center"
          justify="space-between"
          gap={4}
        >
          <Text>&copy; {new Date().getFullYear()} BeatStake. All rights reserved.</Text>
          <Flex gap={4}>
            <Link
              onClick={onTermsOpen}
              fontWeight="bold"
              color="primary.100"
              textDecoration="underline"
              _hover={{ textDecoration: "underline", color: "primary.900" }}
            >
              Terms of Service
            </Link>
            <Link
              onClick={onPrivacyOpen}
              fontWeight="bold"
              color="primary.100"
              textDecoration="underline"
              _hover={{ textDecoration: "underline", color: "primary.900" }}
            >
              Privacy Policy
            </Link>
            <Link
              onClick={onSubscriptionOpen}
              fontWeight="bold"
              color="primary.100"
              textDecoration="underline"
              _hover={{ textDecoration: "underline", color: "primary.900" }}
            >
              Subscription Policy
            </Link>
          </Flex>
        </Flex>
      </Box>

      {/* Modals */}
      <TermsOfServiceModal isOpen={isTermsOpen} onClose={onTermsClose} />
      <PrivacyPolicyModal isOpen={isPrivacyOpen} onClose={onPrivacyClose} />
      <SubscriptionPolicyModal isOpen={isSubscriptionOpen} onClose={onSubscriptionClose} />
      <Contact isOpen={isContactOpen} onClose={closeContact} />
    </Box>
  );
};

export default Footer;